import React from 'react';
import Stylesheet from './Standard.module.css';
import Classnames from 'classnames';
import { ico_spinner } from '../../../icon';

class Loading extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false
        }
    }

    render() {
        let loadingStyle = Classnames(
            Stylesheet.loading, {
                [Stylesheet['show']] : this.props.show,
                [Stylesheet['hide']] : !this.props.show
            }
        )
        return (
            <div className={loadingStyle}>
                <div className={Stylesheet.animation}>
                    <h1>{ico_spinner}</h1>
                </div>
            </div>
        )
    }
}

export default Loading;